function openCartUpsellPopup(event) {
    const popup = document.getElementById('cart-upsell-popup');
    if (popup) {
        popup.style.display = 'block';
    }

    // get product details from data attributes
    const variantId = event.currentTarget.getAttribute('data-variant-id');
    const variantHandle = event.currentTarget.getAttribute('data-variant-handle');
    const productTitle = event.currentTarget.getAttribute('data-product-title');
    const variantTitle = event.currentTarget.getAttribute('data-variant-title');
    const productPrice = event.currentTarget.getAttribute('data-product-price');
    const productDetails = event.currentTarget.getAttribute('data-product-details');

    // populate product details in the popup
    const productDetailsContainer = document.getElementById('cart-upsell-popup-product-details');

    productDetailsContainer.innerHTML = `
    <div class="cart-upsell-popup__product-image-container">
    <swiper-container class="cart-upsell-popup__product-images cart-upsell-swiper"
            init="false"
            navigation="true"
            space-between="35"
            slides-per-view="1"
         >
            ${JSON.parse(event.currentTarget.getAttribute('data-product-images')).map(imgSrc => `
                <swiper-slide class="cart-upsell-popup__thumbnail-slide">
                    <img src="${imgSrc}" alt="${productTitle}" class="cart-upsell-popup__thumbnail-image" width="150px" height="150px" />
                </swiper-slide>
            `).join('')}
        </swiper-container>    
    </div>    
        <div class="cart-upsell-popup__product-info">
            <div class="cart-upsell-popup__product-titles-wrapper">
                <p class="cart-upsell-popup__product-title">${productTitle}</p>
                <p class="cart-upsell-popup__variant-title">${variantTitle}</p>
                <p class="cart-upsell-popup__product-price">${productPrice}</p>
            </div>
            <div class="cart-upsell-popup__product-details-wrapper">
                <p class="cart-upsell-popup__product-details">${productDetails}</p>
            </div>
            <component-addtocart data-handle="${variantHandle}">
                <form action="/cart/add" method="post">
                    <input type="hidden" name="id" value="${variantId}">
                    <input type="hidden" name="quantity" value="1">
                    <input type="hidden" name="properties[tag_value]" value="upsell-cart">
                    <button class="upsell-product_add-to-cart-button" type="submit" name="add">
                        <span>Add to cart</span>
                    </button>
                </form>
            </component-addtocart>
        </div>
    `;

    // enable image zoom
    enableUpsellImageZoom(productDetailsContainer);

    // style and initialize swiper
    const swiper = productDetailsContainer.querySelector('swiper-container');
    if (swiper) {
        const swiperParams = {
            injectStyles: [
                `
                    .swiper-button-next, .swiper-button-prev {
                        height: 25px;
                        width: 25px;
                    }
                    .swiper-button-next svg, .swiper-button-prev svg {
                        height: 11px;
                        width: 11px
                    }
                    .swiper-button-next svg path, .swiper-button-prev svg path {
                        fill: black;
                    }
                `,
            ],
        };

        Object.assign(swiper, swiperParams);
        swiper.initialize();
    }
}

function closeCartUpsellPopup() {
    const popup = document.getElementById('cart-upsell-popup');
    if (popup) {
        popup.style.display = 'none';
    }
}

function enableUpsellImageZoom(container) {
    container.querySelectorAll('.cart-upsell-popup__thumbnail-slide img')
        .forEach(img => {
            img.addEventListener('click', () => {
                img.classList.toggle('is-zoomed');
            });
        });
}
